import { PRODUCT_ID } from 'ck-core/source/data/Product';

const beginner = 'Beginner-friendly code editor';
const courses = 'Video course library teaching you how to code';
const support = 'Fast online support';

export const lang = {
	FEATURES_SUMMARY: {
		[PRODUCT_ID.MINECRAFT]: [beginner, courses, 'Private multiplayer server', support],
		[PRODUCT_ID.ROBLOX]: [beginner, courses, 'Game publishing tutorials', support],
		[PRODUCT_ID.BUNDLE]: [
			'Minecraft courses and code editor',
			'Roblox courses and editor',
			'Private Minecraft multiplayer server',
			'Access to all future platforms',
			support
		]
	}
};
